import { ResendOtpResponse } from '@porterin/booking-flow/src/auth/domain/api-models/ResendOtpApiModel';
import { RESPONSE_MESSAGES } from '@porterin/booking-flow/src/auth/domain/config/responseMessages';
import { ResendOtp } from '@porterin/booking-flow/src/auth/domain/entities/ResendOtp';

const toResendOtpEntity = (_: ResendOtpResponse): ResendOtp => {
  return {
    message: RESPONSE_MESSAGES.RESPONSE_RESEND_OTP_SUCCESS,
  };
};

export { toResendOtpEntity };
